/**
 * A wrapper for Date.toLocaleString that uses the timezone setting from WordPress.
 * @param {Date} date - A date object to format.
 * @param {object} options - Options to pass to Date.toLocaleString.
 * @returns {string} - The formatted date.
 */
export default function formatDate(date, options) {
  const {
    knightConfig: {
      timezone = '',
    } = {},
  } = window;

  // If there is no configured timezone, bail out.
  if (! timezone) {
    return '';
  }

  // Ensure the date is a valid date.
  if (Number.isNaN(date.getYear())) {
    return '';
  }

  return date.toLocaleString('en-US', {
    timezone,
    ...options,
  });
}
